import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "treeView",
  class: "component-groups-tree-container"
}
const _hoisted_2 = { style: {"margin-bottom":".6rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          placeholder: "Фильтр по названию",
          clearable: "",
          modelValue: _ctx.filterGroupsTreeQuery,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterGroupsTreeQuery) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_scrollbar, { class: "component-groups-scrollbar" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tree, {
              loading: _ctx.isAsyncOperationPending,
              ref: "elTree",
              class: "component-groups-tree",
              "show-checkbox": "",
              "check-strictly": "",
              "node-key": "value",
              data: _ctx.tree,
              props: { children: 'children', label: 'label' },
              "filter-node-method": _ctx.filterGrpupsTree,
              onCheckChange: _ctx.onParentGroupTreeChange
            }, {
              empty: _withCtx(() => [
                _createTextVNode("   ")
              ]),
              _: 1
            }, 8, ["loading", "data", "filter-node-method", "onCheckChange"])
          ]),
          _: 1
        })
      ])
    ])), [
      [_directive_loading, _ctx.isAsyncOperationPending]
    ]),
    (!_ctx.disableRoot)
      ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          label: "Корневая группа",
          disabled: _ctx.isAsyncOperationPending,
          modelValue: _ctx.isRootFolderSelected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isRootFolderSelected) = $event)),
          onChange: _ctx.onChecboxRootGroupChange
        }, null, 8, ["disabled", "modelValue", "onChange"]))
      : _createCommentVNode("", true)
  ], 64))
}